// Datas no horário de Brasília (America/Sao_Paulo, o mesmo fuso da API), independente
// do fuso configurado no computador. toISOString() usa UTC: depois das 21h já seria o
// dia seguinte. "en-CA" formata como AAAA-MM-DD.
const FORMATO_BRASILIA = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" });

export function dataBrasilia(data = new Date()) {
  return FORMATO_BRASILIA.format(data);
}

export function hojeBrasilia() {
  return dataBrasilia(new Date());
}

// Dia de um Date montado no próprio navegador (ex.: dia clicado num calendário):
// usa o dia do objeto, sem conversão de fuso, para não voltar ou avançar um dia.
export function dataDoObjeto(data) {
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${data.getFullYear()}-${mes}-${dia}`;
}
